export function isTruthy(val) {
    if (val === undefined) return false;
    if (val === null) return false;
    // booleans equal themselves
    if (typeof val === 'boolean') return val;
    // objects are truthy (note null test above, since typeof null === 'object')
    if (typeof val === 'object') return true;
    // look for truthy string values
    if (typeof val === 'string') {
        var lval = val.toLowerCase();
        switch (lval) {
            case '1':
            case 'y':
            case 'yes':
            case 't':
            case 'true':
            case 'on':
            case 'ok':
            case 'checked':
            case 'selected':
            case 'enabled':
                return true;
        }
    }
    // not very truthy
    return false;
}
